import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { StatusService } from './status.service';
import { IStatus } from './status.interfaces';

@Component({
  selector: 'status-outlet',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss'],
})
export class StatusBarComponent implements OnInit, OnDestroy {
  status: IStatus[] = [];
  statusLength: number;

  private readonly subscription = new Subscription();

  constructor(private readonly statusService: StatusService) { }

  ngOnInit(): void {
    this.subscription.add(this.statusService.status$.subscribe((statusObject) => {
      this.status = [];

      Object.keys(statusObject).forEach((status) => {
        if (!statusObject[status]) {
          return;
        }

        this.status.push(statusObject[status]);
      });

      this.statusLength = this.status.length;
    }));
  }

  close(state: IStatus): void {
    this.statusService.clearStatusById(state.id);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  isReload(status: IStatus): boolean {
    return status.body === 'refresh';
  }

  reload(): void {
    window.location.reload();
  }
}
